import React from "react";

const PelaseLogin = () => {
  return (
    <div className="o-appointment">
      <div className="o-appointment__container">
        <span>🚨 Por favor inicia sesión.</span>
      </div>
    </div>
  );
};

export default PelaseLogin;
